export const evaluation = [
    {letter: 'N/A', color: '#ffffff', score: 0},
    {letter: 'D',   color: '#cc0000', score: 1, semaphore: 1},
    {letter: 'C',   color: '#ff0606', score: 2},
    {letter: 'CC',  color: '#ff7070', score: 3},
    {letter: 'CCC', color: '#ffadad', score: 4},
    {letter: 'B',   color: '#ff9900', score: 5, semaphore: 2},
    {letter: 'BB',  color: '#ffe633', score: 6},
    {letter: 'BBB', color: '#D4E157', score: 7},
    {letter: 'A',   color: '#9CCC65', score: 8},
    {letter: 'AA',  color: '#4CAF50', score: 9},
    {letter: 'AAA', color: '#2E7D32', score: 10, semaphore: 3}
]

export const find_evaluation = ({score, semaphore, letter}) => {
    if(score != null)
	return evaluation.filter(x => x.score==score)[0]
    if(semaphore != null)
	return evaluation.filter(x => x.semaphore==semaphore)[0]
    if(letter != null)
	return evaluation.filter(x => x.letter==letter)[0]
    return {letter: '-'}
}
